import { tr } from 'i18n';
import axios from 'axios'

export const API_URL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api/').replace(/\/?$/, '/')
const mediaField = /^(?:imeag|avatar_url|photo(?:_.*)?|(?:entered|exit)_(?:vehicle|plate)_photo|qr_code|(?:old_|new_)?file(?:_url)?|(?:passport|license|tech_passport)_(?:front|back)(?:_url)?)$/
export function resolveMediaPaths(value, key = '') {
  if (typeof value === 'string' && mediaField.test(key) && value.startsWith('/media/')) return new URL(value, API_URL).href
  if (Array.isArray(value)) return value.map(item => resolveMediaPaths(item))
  if (value && Object.getPrototypeOf(value) === Object.prototype) return Object.fromEntries(Object.entries(value).map(([field, item]) => [field, resolveMediaPaths(item, field)]))
  return value
}
let refreshRequest = null
let apiStatusHandler = null
let sessionRevision = 0
let observedRefresh = localStorage.getItem('refresh')
const currentSession = () => {
  const refresh = localStorage.getItem('refresh')
  if (refresh !== observedRefresh) { observedRefresh = refresh; sessionRevision += 1 }
  return sessionRevision
}
export const setApiStatusHandler = handler => { apiStatusHandler = handler }
export function updateSessionTokens(data) {
  if (!data.access) return
  sessionRevision += 1
  localStorage.setItem('token', data.access)
  if (data.refresh) localStorage.setItem('refresh', data.refresh)
  observedRefresh = localStorage.getItem('refresh')
}
export function clearSession() {
  sessionRevision += 1
  observedRefresh = null
  ;['token', 'refresh', 'user', 'rememberMe'].forEach(key => localStorage.removeItem(key))
  sessionStorage.removeItem('erp-session')
}
export function createApiClient() {
  const client = axios.create({ baseURL: API_URL, withCredentials: true, headers: { Accept: 'application/json' } })
  client.interceptors.request.use(config => {
    if (config._erpSessionRevision === undefined) config._erpSessionRevision = currentSession()
    const token = localStorage.getItem('token')
    if (token && !config.headers.Authorization) config.headers.Authorization = 'Bearer ' + token
    return config
  })
  client.interceptors.response.use(response => {
    response.data = resolveMediaPaths(response.data)
    apiStatusHandler?.(false)
    return response
  }, async error => {
    const config = error.config
    if (!error.response || [502, 503, 504].includes(error.response.status)) apiStatusHandler?.(true)
    const refresh = localStorage.getItem('refresh')
    if (error.response?.status === 401 && refresh && config && !config.erpAuthStep && !config._erpRetry && !/account\/token\/|employees\/checkpin\//.test(config.url)) {
      const revision = currentSession()
      if (config._erpSessionRevision !== revision) return Promise.reject(error)
      config._erpRetry = true
      try {
        const token = localStorage.getItem('token')
        if (token && config.headers.Authorization !== 'Bearer ' + token) {
          config.headers.Authorization = 'Bearer ' + token
          return client(config)
        }
        if (!refreshRequest || refreshRequest.revision !== revision) {
          const job = { revision }
          job.promise = axios.post(API_URL + 'account/token/refresh/', { refresh })
          .then(({ data }) => {
            if (currentSession() !== revision || localStorage.getItem('refresh') !== refresh) throw new Error(tr("Сессия уже завершена или изменена."))
            localStorage.setItem('token', data.access)
            if (data.refresh) { localStorage.setItem('refresh', data.refresh); observedRefresh = data.refresh }
            return data.access
          })
          .finally(() => { if (refreshRequest === job) refreshRequest = null })
          refreshRequest = job
        }
        const access = await refreshRequest.promise
        if (currentSession() !== revision || localStorage.getItem('token') !== access) throw new Error(tr("Сессия уже завершена или изменена."))
        config.headers.Authorization = 'Bearer ' + access
        return client(config)
      } catch (refreshError) {
        if (refreshError.response?.status === 401 && currentSession() === revision && localStorage.getItem('refresh') === refresh) { clearSession(); window.dispatchEvent(new Event('erp-session-expired')) }
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  })
  return client
}
